import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarPratica from '../../components/modal/ModalCadastrarPratica';
import ModalEditarPratica from '../../components/modal/ModalEditarPratica';
import ModalExcluirPratica from '../../components/modal/ModalExcluirPratica';
import { ServicoContext } from '../../context/ServicoContext';
import Tabela from '../../components/Tabela';

function Pratica() {
    const { Success, Error, openModal, setOpenModal, PraticasConsulta, ListaPraticaConsulta, loading, modalEditarPratica, setModalEditarPratica, setEdicaoPratica, setPraticaAtualKey, modalExcluirPratica, setModalExcluirPratica, InativarPratica, ListaFiltroPratica, totalRegistrosPratica, filtroPratica, totalRegistrosFiltroPratica } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditPratica = (props) => {
        setModalEditarPratica(true)
        setPraticaAtualKey(props.key)
        setEdicaoPratica(props)
    }

    const DeletarPratica = (props) => {
        setPraticaAtualKey(props.key)
        setModalExcluirPratica(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroPratica(searchTerm, currentPage, pageSize);
        } else {
            ListaPraticaConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroPratica : totalRegistrosPratica;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar práticas de referência'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarPratica &&
                <ModalEditarPratica currentPage={currentPage} />
            }
            {modalExcluirPratica &&
                <ModalExcluirPratica currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarPratica closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar prática de referência</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Práticas de Referência cadastradas</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroPratica : PraticasConsulta}
                            columns={[
                                { label: "Prática de Referência", field: "nome", width: "40%" },
                                { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                                {
                                    label: "Ativo",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarPratica(x.key, !x.ativo)} checked={x.ativo} />
                                        </div>
                                    ),
                                },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditPratica(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarPratica(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroPratica(term, 1, 10);
                                } else {
                                    ListaPraticaConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Pratica;